import React from 'react';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';

const PublicLayout = ({ children, centered = true }) => {
  if (centered) {
    // Centered layout for login/register
    return (
      <div className="min-h-screen bg-gradient-to-br from-background-light-secondary to-gray-100 dark:from-background-dark dark:to-gray-900 flex flex-col">
        <TopBar />
        <div className="container mx-auto px-4 py-8 flex-grow">
          <div className="flex flex-col items-center justify-center min-h-[calc(100vh-8rem)]">
            <div className="mb-8 text-center">
              <h1 className="text-4xl font-bold logo-text text-primary-600 dark:text-primary-400 mb-2">Kwasai</h1>
              <p className="text-secondary">Master & slave Social Network</p>
            </div>
            <div className="w-full max-w-md">
              {children}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  // Full-width layout for CMS pages
  return (
    <div className="min-h-screen bg-secondary flex flex-col">
      <TopBar />
      <main className="container mx-auto px-4 py-8 flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
